import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "font-semibold" }

import { ref } from 'vue';

    
export default /*@__PURE__*/_defineComponent({
  __name: 'ConfirmationModal',
  setup(__props, { expose: __expose }) {

    const title = ref('');
    const message = ref('');
    const isModalOpen = ref(false);
    let promise: Promise<boolean>;
    let resolvePromise: any;
    let rejectPromise: any;

    async function open(_title: string, _message: string) {
        title.value = _title;
        message.value = _message;
        promise = new Promise((resolve, reject) => {
            resolvePromise = resolve;
            rejectPromise = reject;
        });
        isModalOpen.value = true;
        return await promise;
    }

    function onClose() {
        resolvePromise(false);
    }

    function onConfirm() {
        resolvePromise(true);
        isModalOpen.value = false;
    }

    function onReject() {
        resolvePromise(false);
        isModalOpen.value = false;
    }

    __expose({ open });

return (_ctx: any,_cache: any) => {
  const _component_custom_modal = _resolveComponent("custom-modal")!

  return (_openBlock(), _createBlock(_component_custom_modal, {
    show: isModalOpen.value,
    "onUpdate:show": _cache[0] || (_cache[0] = ($event: any) => ((isModalOpen).value = $event)),
    onClosed: onClose
  }, {
    header: _withCtx(() => [
      _createElementVNode("h4", _hoisted_1, _toDisplayString(title.value), 1)
    ]),
    footer: _withCtx(() => [
      _createElementVNode("button", {
        id: "btn-confirmation-confirm",
        class: "btn-ultra white2",
        style: {"justify-content":"center"},
        onClick: onConfirm
      }, "Oui"),
      _createElementVNode("button", {
        id: "btn-confirmation-reject",
        class: "btn-ultra white2",
        style: {"justify-content":"center"},
        onClick: onReject
      }, "Non")
    ]),
    default: _withCtx(() => [
      _createElementVNode("p", null, _toDisplayString(message.value), 1)
    ]),
    _: 1
  }, 8, ["show"]))
}
}

})